/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormField,
  FormItem,
  FormControl,
  DatePicker,
  Input,
  Checkbox,
  cn,
} from "@repo/ui";
import { useNavigate } from "react-router-dom";
import { ExcelRenderer } from "react-excel-renderer";
import { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import sweetAlert from "components/sweet-alert";
import { Label } from "ui/label";
import { useCreateBulkTicket } from "services/tickets";
import Loader from "ui/page-loader";
import { getLocalISODateString } from "utils/date-utils";

export default function CreateBulkTickets() {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();
  const form = useForm({ defaultValues: { serviceDate: null, file: null } });

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useCreateBulkTicket();

  useEffect(() => {
    if (createTicketRes) {
      navigate(-1);
    }
  }, [createTicketRes]);

  const validateTicketItem = (item) => {
    return (
      item.AssetId &&
      item.ActivityType &&
      item.Category &&
      item.SubCategory &&
      item.AssignmentGroup
    );
  };

  const buildTicketPayloadItem = (item) => ({
    assetId: item.AssetId || "",
    activityType: item.ActivityType || "",
    category: item.Category || "",
    subCategory: item.SubCategory || "",
    description: item.Description || "",
    vaultAccessRequired: item.VaultAccessRequired || false,
    bankReferenceNo: `${item.BankReferenceNo || ""}`,
    assignmentGroup: item.AssignmentGroup || "",
    assignedTo: `${item.AssignedTo || ""}` || "",
    routeNo: item.RouteNo || "",
    primaryAssigneeId: `${item.PrimaryAssigneeId || ""}` || "",
    secondaryAssigneeId: `${item.SecondaryAssigneeId || ""}` || "",
    reportedBy: `${item.ReportedBy || ""}`,
  });

  const validateAllTickets = (tickets) => {
    for (const item of tickets) {
      if (!validateTicketItem(item)) {
        sweetAlert({
          title: "Invalid Data",
          text: "Required Fields Are Missing In List",
          icon: "error",
        });
        return false;
      }
    }
    return true;
  };

  const buildPayload = (data, tickets) => ({
    serviceDate: getLocalISODateString(data.serviceDate),
    tickets: tickets.map(buildTicketPayloadItem),
  });

  const showConfirmationDialog = (serviceDate, onConfirm) => {
    sweetAlert({
      title: "Operation Confirmation",
      text: `Are you sure you want to create tickets for ${moment(serviceDate).format("DD-MM-YYYY")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm,
    });
  };

  const onSave = (data) => {
    if (!validateAllTickets(tickets)) {
      return;
    }

    const payload = buildPayload(data, tickets);

    showConfirmationDialog(form.getValues("serviceDate"), () =>
      createTicket(payload)
    );
  };

  const processExcelData = (rows, field) => {
    const ticketsList = [];
    const keys = rows.shift(); //keys,header

    rows.forEach((elm) => {
      if (!elm || !elm.length) return;

      const _ticket = createSingleTicket(elm, keys);
      ticketsList.push(_ticket);
    });

    setTickets(ticketsList);
    field.onChange(ticketsList);
  };

  const createSingleTicket = (rowData, keys) => {
    const _ticket = {};

    rowData.forEach((item, index) => {
      _ticket[keys[index]] = item;
    });

    keys.forEach((key) => {
      if (_ticket[key] === undefined) {
        _ticket[key] = "";
      }
    });

    return _ticket;
  };

  const handleExcelError = (err) => {
    sweetAlert({ title: "Operation Failure", text: err, icon: "error" });
  };

  const handleFileUploadError = () => {
    sweetAlert({
      title: "File Upload Failed",
      text: "Can Not Upload File",
      icon: "error",
    });
  };

  const fileHandler = (event, field) => {
    if (!event?.target?.files) {
      handleFileUploadError();
      return;
    }

    const fileObj = event.target.files[0];
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        handleExcelError(err);
        return;
      }
      processExcelData(resp.rows, field);
    });
  };

  return (
    <>
      {creatingTicket ? <Loader /> : <></>}

      <Card className="mt-4 overflow-hidden w-full">
        <CardHeader>
          <CardTitle>
            <div className="flex flex-row justify-between w-full gap-2">
              Create Tickets
              <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
                Save
              </Button>
            </div>
          </CardTitle>
        </CardHeader>

        <Form {...form}>
          <form className="space-y-8 custom-form-v2">
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              <div className="form-row-d-50 [&>.space-y-2]:!w-full">
                <FormField
                  control={form.control}
                  name="serviceDate"
                  rules={{ required: "Please Select Date" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Service Date" isRequired />
                      <FormControl>
                        <div
                          className={cn(
                            "form-date-picker",
                            form.formState?.errors?.serviceDate
                              ? "border-red-500"
                              : "border-secondary"
                          )}
                        >
                          <DatePicker
                            variant="secondary"
                            selectedDate={field.value}
                            placeholder="Select Date"
                            onSelectDate={field.onChange}
                            mode="single"
                            disabled={{ before: new Date() }}
                          />
                          {form.formState?.errors?.serviceDate ? (
                            <p className="text-destructive text-xs">
                              Please Select Date
                            </p>
                          ) : null}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
                <div style={{ width: "100%" }} />
                <FormField
                  control={form.control}
                  name="file"
                  rules={{ required: "Please Upload File" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Upload File" isRequired />
                      <FormControl>
                        <div>
                          <Input
                            style={
                              form.formState?.errors?.file
                                ? { borderColor: "red" }
                                : {}
                            }
                            type="file"
                            onChange={(event) => {
                              fileHandler(event, field);
                            }}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                          {form.formState?.errors?.file ? (
                            <p className="text-destructive text-xs">
                              Please Upload File
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>

              {tickets.length > 0 ? (
                <Grid
                  data={tickets}
                  className="list-tables-v1"
                  style={{ overflow: "hidden" }}
                >
                  <GridColumn title="Asset Id" field="AssetId" width="120px" />
                  <GridColumn
                    title="Activity Type"
                    field="ActivityType"
                    width="120px"
                  />
                  <GridColumn title="Category" field="Category" width="120px" />
                  <GridColumn
                    title="Sub Category"
                    field="SubCategory"
                    width="170px"
                  />
                  <GridColumn
                    title="Bank Reference No"
                    field="BankReferenceNo"
                    width="200px"
                  />
                  <GridColumn
                    title="Assignment Group"
                    field="AssignmentGroup"
                    width="200px"
                  />
                  <GridColumn
                    title="Assigned To"
                    field="AssignedTo"
                    width="120px"
                  />
                  <GridColumn title="Route No" field="RouteNo" width="120px" />
                  <GridColumn
                    title="Primary Assignee Id"
                    field="PrimaryAssigneeId"
                    width="170px"
                  />
                  <GridColumn
                    title="Secondary Assignee Id"
                    field="SecondaryAssigneeId"
                    width="200px"
                  />
                  <GridColumn
                    title="Reported By"
                    field="Reported By"
                    width="120px"
                  />

                  <GridColumn
                    title="Vault Access Required"
                    width="170px"
                    cell={(dataItem) => (
                      <td>
                        <div className="flex items-center justify-center w-full">
                          <Checkbox
                            checked={dataItem.vaultAccessRequired}
                            disabled
                          />
                        </div>
                      </td>
                    )}
                  />
                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </form>
        </Form>
      </Card>
    </>
  );
}
